/**
 * Copyright 2022 (C) Blink - All Rights Reserved
 *
 * This source code is protected under international copyright law.  All rights
 * reserved and protected by the copyright holders.
 * All files are confidential and only available to authorized individuals with the
 * permission of the copyright holders. If you encounter any file and do not have
 * permission, please get in touch with the copyright holders and delete this file.
 */

import { getTimeFromDate } from "utils/dateUtils";
import Stack from "../Stack";
import Heading from "../Heading";
import { Button } from "../Button";
import Text from "../Text";

const NotificationCard = ({ notification, handleTapToView, onClick }) => {
  return (
    <Stack
      className="pb-s10 max-w-sm border-b-2 border-btn-inactive"
      test-id="U0j5-Pfi"
    >
      <Stack className="mb-s10" test-id="f-ey5k07">
        <div className="flex justify-between" test-id="DOWQEA4I">
          <Heading as="h4" className="text-light-gray" test-id="Y5_HjRUG">
            {notification.title}
          </Heading>
          <Text className="text-light-gray" test-id="nUTPCZ29">
            {getTimeFromDate(notification.created_at)}
          </Text>
        </div>

        <Text test-id="hRcl1RQI">{notification.body}</Text>
      </Stack>

      <Button
        variant="unstyled"
        onClick={() => {
          handleTapToView(notification);
          onClick();
        }}
        test-id="-gMqT8Jw"
      >
        Review
      </Button>
    </Stack>
  );
};

export default NotificationCard;
